module.exports = window.jimdoData || window.parent.jimdoData;


/*****************
 ** WEBPACK FOOTER
 ** external "window.jimdoData || window.parent.jimdoData"
 ** module id = 4
 ** module chunks = 99 100 102 103 104 234 235 239 242 244 245 246 249 250
 **/